<ion-content style="position: relative;" class="ion-padding" style="--padding-top: 0">
  <ion-toolbar style="position: sticky;top: 0;z-index: 100;">
    <ion-list style="padding-top: 20px;">
      <ion-item lines="none">
        <ion-searchbar debounce="1500" style="--border-radius: 50px;position: sticky;top: 0;z-index: 100;"
          [placeholder]="manager.Trad.Parse('STR_PLACEHOLDER')" [(ngModel)]="Filter" class="custom"></ion-searchbar>
        <ion-buttons style="margin: 0;" slot="end">
          <ion-button style="margin: 0;" color=""
            (click)="this.manager.DismissTopModal()">{{manager.Trad.Parse("STR_CONFIRME")}}</ion-button>
        </ion-buttons>
      </ion-item>
      <ion-item *ngIf="Current != null && TargetField!='State'" (click)="getBack()"
        style="font-weight: bold;color:#757575">
        <ion-icon name="chevron-back-outline"></ion-icon>
        {{manager.Trad.Parse(fullParentLabel)}}
      </ion-item>
    </ion-list>
  </ion-toolbar>

  <div style="text-align: center; width: 100%;" *ngIf="!Contents?.length && !IsLoading && Opened">
    {{manager.Trad.Parse("STR_EMPTY")}}</div>
  <div style="text-align: center; width: 100%" *ngIf="!Contents?.length && (IsLoading || !Opened) ">
    {{manager.Trad.Parse("STR_LOADING")}}</div>
  <ion-list [style]="Css" *ngIf="Contents?.length && !IsLoading && Opened">
    <ion-item [id]="content.value" (click)="onSelect(content)" *ngFor="let content of Contents"
      style="--border-color: var(--ion-color-secondary); --padding-start: 0px;  --inner-padding-end: 0px;">
      <ion-label color="{{ isSelected(content) ? 'primary' : 'secondary' }}" class="ion-text-wrap"
        style="font-weight: bold;">{{manager.Trad.Parse(content.label)}}</ion-label>
      <ion-icon *ngIf="gotChild(content)" name="chevron-forward-outline" slot="end"></ion-icon>
      <ion-icon *ngIf="isSelected(content)" name="checkmark-circle" slot="end" color="primary" size="large"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>